import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { custom, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import UserDefinedTab from './tabs/UserDefinedTab';
import { IM, WM } from "../../../const/constants";
import ValidationSummary from 'devextreme-react/validation-summary';
import { MESSAGES } from "../../../common/Messages";
import routes from "../../../assets/apiRoutes.json";
import PrimaryTab from "./tabs/PrimaryTab";
import { locationTypes, optionsYesNo, status } from "../../../const/Lookup";
import { GetFormatedDateWithTime, loadLookupFromStaticDataSource } from "../../../common/Utils";
import { LocationStatus, LocationTypes as LocType, Options } from "../../../enum/Enum";
import AdditionalTab from "./tabs/AdditionalTab";
import ContentsDetailTab from "./tabs/ContentsDetailTab";
var skipDataLoading = false;
function LocationDataEntryForm(props) {
    const [dialogVisible, setDialogVisible] = useState(false);

    const closeDialog = () => {
        setDialogVisible(false);
    };
    const initialFormFields = {
        RowId: '00000000-0000-0000-0000-000000000000',
        KeySequence: 1,
        CrateNumber: null,
        Description: null,
        Dimensions: null,
        Height: null,
        Width: null,
        Depth: null,
        Cube: null,
        GrossWeightQuantity: null,
        NetWeightQuantity: null,
        ReceivedDate: null,
        ShippedDate: null,
        RecordNumber: null,
        CreationDateTime: null,
        CreationUserId: null,
        LastUpdateDateTime: null,
        LastUpdateUserId: null,
        CompanyId: null,
        RecordType: null,
        Status: null,
        UserdefinedCode1: null,
        UserdefinedCode2: null,
        UserdefinedCode3: null,
        UserdefinedCode4: null,
        UserdefinedCode5: null,
        UserDefinedReference1: null,
        UserDefinedReference2: null,
        UserDefinedReference3: null,
        UserDefinedReference4: null,
        UserDefinedReference5: null,
        UserDefinedDate1: null,
        UserDefinedDate2: null,
        UserDefinedDate3: null,
        UserDefinedDate4: null,
        UserDefinedDate5: null,
        UserDefinedQuantity1: null,
        UserDefinedQuantity2: null,
        UserDefinedQuantity3: null,
        UserDefinedQuantity4: null,
        UserDefinedQuantity5: null,
        UserDefinedComment: null,
        Module: props.Module,
        RProfile: null,
        RWarehouse: null,
        RLocation: null,
        ROwner: null,
        TareWeightQuantity: null,
        SSCCNumber : null,
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const formFieldsRef = useRef(formFields);
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    useEffect(() => {
        if (formFields)
            formFieldsRef.current = formFields;
    }, [formFields])

    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            await updateTransaction();
        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const updateTransaction = async () => {
        try {
            setLoadPanelVisible(true);
            let fields = formatDates();
            const response = await axios.put(`${window._env_.REACT_APP_APIS}/${routes.IM.UpdateCrates}`, fields, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (response.data.issuccess) {

                notify(
                    {
                        message: MESSAGES.UPDATE_SUCCESS,
                        width: 300,
                    },
                    'success',
                    3000,
                );
                var rowid = props.id;
                if (rowid != null && rowid != undefined && rowid != '') {
                    GetHeaderInfoById(rowid);
                }
            } else {
                const errorHtml = (response.data.message || "").replace(/\\r\\n|\r\n|\n/g, "<br/>");
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
                setIsFormSubmitted(false);
            }

        } catch (error) {
            console.error(MESSAGES.ERROR_FORM_SUBMISSION, error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);
            setLoadPanelVisible(false);
        }
    };
    const formatDates = () => {
        let fields = formFields;
        fields.ReceivedDate = GetFormatedDateWithTime(formFields.ReceivedDate);
        fields.ShippedDate = GetFormatedDateWithTime(formFields.ShippedDate);

        fields.UserDefinedDate1 = GetFormatedDateWithTime(formFields.UserDefinedDate1);
        fields.UserDefinedDate2 = GetFormatedDateWithTime(formFields.UserDefinedDate2);
        fields.UserDefinedDate3 = GetFormatedDateWithTime(formFields.UserDefinedDate3);
        fields.UserDefinedDate4 = GetFormatedDateWithTime(formFields.UserDefinedDate4);
        fields.UserDefinedDate5 = GetFormatedDateWithTime(formFields.UserDefinedDate5);
        return fields;
    };
    const handleReset = () => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            skipDataLoading = true;
            setformFields(initialFormFields);
            skipDataLoading = false;
            EnableDisableControls();
        }
    };
    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            const response = axios.get(`${window._env_.REACT_APP_APIS}/${routes.IM.GetCrate}?rowId=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                console.log(responseData)
                if (responseData.RowId) {
                    skipDataLoading = true;
                    setformFields(responseData);
                    skipDataLoading = false;
                }
                else {
                    console.error(MESSAGES.FETCH_ERROR);
                }
            });


        } catch (error) {
            console.error(MESSAGES.FETCH_ERROR, error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const EnableDisableControls = () => {
    }
    useEffect(() => {
        var rowid = props.id;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetHeaderInfoById(rowid);
        }
        else {
            EnableDisableControls();
        }
    }, []);
    const goBack = () => {
        if (props.Module === WM)
            history.push("/wm/codes/crate-data-entry");
        else if (props.Module === IM)
            history.push("/im/codes/crate-data-entry");
    };
    const handleFieldChange = useCallback((name, value, e, formRefs) => {

    }, []);
    const handlePrimaryFormLoad = useCallback((formRefs) => {

    }, []);


    return (
        <>
            <div>
                <div className="row dataEntryMainPage">
                    <div className="col-md-12 main-page">
                        <div id="accordion">

                            <LoadPanel
                                shadingColor="rgba(0,0,0,0.4)"
                                position={position}
                                onHiding={hideLoadPanel}
                                visible={loadPanelVisible}
                                showIndicator={true}
                                shading={true}
                                showPane={true}
                                hideOnOutsideClick={false}
                            />
                            <form onSubmit={(e) => handleFormSubmit(e)}>
                                <Toolbar className="header">
                                    <Item location="before">
                                        <div className="title">
                                            <h6
                                                style={{
                                                    color: window._env_.Color2,
                                                    marginLeft: '12px'
                                                }}
                                            >
                                                Enter Crate Codes
                                            </h6>
                                        </div>
                                    </Item>
                                    <Item location="after">
                                        <Button
                                            text="Save"
                                            useSubmitBehavior={true}
                                            type="default"
                                            className="accordianButton"
                                        />
                                    </Item>

                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={goBack} text="Back" />
                                    </Item>

                                </Toolbar>
                                <div className="AccordionItemBody">
                                    <TabPanel className="TabpanelContainer">
                                        <TabItem title="Primary">
                                            <PrimaryTab
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                formRefs={formRefs}
                                                handlePrimaryFormLoad={handlePrimaryFormLoad}
                                                handleFieldChange={handleFieldChange}
                                                Module={props.Module}
                                            />
                                        </TabItem>
                                        <TabItem title="Additional">
                                            <AdditionalTab
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                formRefs={formRefs}
                                                dialogVisible={dialogVisible}
                                                closeDialog={closeDialog}
                                                handleFieldChange={handleFieldChange}
                                            />
                                        </TabItem>
                                        <TabItem title="User Defined">
                                            <UserDefinedTab
                                                formFields={formFields}
                                                setformFields={setformFields}
                                                formRefs={formRefs}
                                                dialogVisible={dialogVisible}
                                                closeDialog={closeDialog}
                                                Module={props.Module}
                                            />
                                        </TabItem>
                                        <TabItem title="Contents Detail" disabled={formFields.RowId === '00000000-0000-0000-0000-000000000000'} >
                                            <ContentsDetailTab  sourceId={formFields.RowId} Module={WM} />
                                        </TabItem>
                                    </TabPanel>
                                </div>
                                <div className="row">
                                    <ValidationSummary className="pl-3 pt-1" id="summary" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>

        </>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LocationDataEntryForm);